/* eslint-disable */
import React, { Fragment, useState } from 'react';
import { Dialog, Menu, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function SideMenu() {
  const location = window.location;
  const enable = localStorage.getItem('services_enable'); 
  const rampsAllowed = enable === 'ALL' || enable === 'RAMP';
  const baasAllowed  = enable === 'ALL' || enable === 'BAAS';
  
  const [showMenu, setShowMenu] = useState(false);
  const [home, setHome] = useState(false);
  const [clients, setClients] = useState(false);
  const [orders, setOrders] = useState(false);

  const logout = () => {
  localStorage.removeItem('jwt_token');     
  localStorage.removeItem('services_enable'); 
  localStorage.setItem('token', '');
  localStorage.setItem('nameUser', '');
  localStorage.setItem('emailUser', '');
  window.location.href = '/login';
};

  function getUrl(item) {
    switch(item) {
      case 'home':
        window.location.href = '/user';
        break;
      case 'clients':
        window.location.href = '/user';
        break;
      case 'orders':
        window.location.href = '/user';
        break;
      case 'ramps':
        window.location.href = '/ramps';
        break;
      case 'signOut':
        logout();
        break;

      default:
        break;
    }
  }

  function init() {
    let data = {
      email: localStorage.getItem('emailUser')
    };
  }

  function getLetter(name) {
    let letter = "" + name[0];
    if(name.indexOf(" ") > 0){
      for(let i=0; i<name.length; i++){
        if(name[i] === ' ' && name.length>i+1){
          letter = letter + name[i+1];
          return letter.toUpperCase();
        }
      }
    }
    letter = letter + name[1];
    return letter.toUpperCase();
  }

  function getName(name) {
    try{
      var tmp = name.split(" ");
      return (tmp.length>1?tmp[0] + " " + tmp[tmp.length-1]:tmp[0]);
    }
    catch(err){
      return '';
    }
  }

  function handleInputChange(event) {
  }

  React.useEffect(() => {
    init();
  },[]);

  return (
    <section id="sideMenuComponent">

      {
        // --------------------------------------------- DESKTOP --------------------------------------------------- //
      }

      <div className="desktop">
        <div style={{display: "flex", minHeight: "100%", flexDirection: "column"}}>
          <div className="logoLeft" style={{margin: "0px 0px 10px 13px"}}>
            <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Ícone Higher" style={{cursor: "pointer"}} className="iconHigherImage" onClick={() => {window.location.href = '/user';setShowMenu(false);}}/>
            higher
          </div>
          <div className="contentName" style={{marginLeft: "10px"}}>
            <div className="contentLetter">
              {getLetter(localStorage.getItem('nameUser')+"")}
            </div>

            <div className="contentCardData">
              <div className="title">
                <p style={{fontWeight: "bold", margin: "-7px 0px 5px 0px"}}>
                  {""+getName(localStorage.getItem('nameUser'))}
                </p>
                <p className="subtitle" style={{fontWeight: "normal"}}>Higher</p>
              </div>
            </div>
            <br/>
          </div>
          
          {baasAllowed && (
          <div className="btnSimple" onClick={() => {window.location.href = '/user';setShowMenu(false);}} style={(location.pathname==="/user"?{color: "#00E52E", fontWeight: "bold", marginTop: "30px"}:{marginTop: "30px"})}
            onMouseOver={() => setHome(true)}
            onMouseOut={() => setHome(false)}
          >
            {
              (location.pathname === "/user" || home) &&
              <img src={require("../../assets/imgs/m-ordens.svg").default} alt="Ícone menu lateral" className="iconMenu"/>
            }
            {
              location.pathname !== "/user" && !home &&
              <img src={require("../../assets/imgs/m-dashboard.svg").default} alt="Ícone menu lateral" className="iconMenu"/>
            }
            <b>Dashboard</b>
          </div>
          )}

          {rampsAllowed && (
            <div 
            className="btnSimple"
            onClick={() => {window.location.href = '/ramps'; setShowMenu(false);}}
            style={
              location.pathname === "/ramps"
                ? { color: "#00E52E", fontWeight: "bold", marginTop: "14px" }
                : { marginTop: "14px" }
            }
          >
            <img
              src={require("../../assets/imgs/m-dashboard.svg").default} 
              alt="Ícone menu lateral"
              className="iconMenu"
            />
            <b>Ramps / Remessa</b>
          </div>
        )}


  <div onClick={() => {setShowMenu(false);logout()}} className="btnSimple" style={{fontWeight: "bolder", position: "absolute", bottom: "20px"}}>
            Sair&nbsp;&nbsp;&nbsp;
            <img src={require("../../assets/imgs/ico-logout.svg").default} alt="Ícon menu lateral" className="iconMenu"/>
          </div>
        </div>
      </div>


















      {
        // --------------------------------------------- MOBILE --------------------------------------------------- //
      }

      <span className="mobile">
        <div>
          <div className="contentFakeHeader">
          </div>
          <div className="contentHeader">
            <div className="container" onClick={(e) => {e.preventDefault();setShowMenu(!showMenu);}}>
              <input type="checkbox" id="checkbox-menu"/>

              <label htmlFor="checkbox-menu">
                <span></span>
                <span></span>
                <span></span>
              </label>
            </div>

            <div className="contentIconKeyInput">
              <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Ícone Higher" style={{cursor: "pointer"}} className="iconKeyInput" onClick={() => {window.location.href = '/user';setShowMenu(false);}}/>

              <div className="contentLetter">
                {getLetter(localStorage.getItem('nameUser')+"")}
              </div>
            </div>
          </div>

          <Transition.Root show={showMenu} as={Fragment} style={{zIndex: "1000"}}>
            <Dialog as="div" className="relative z-10" onClose={setShowMenu}>
              <div className="fixed inset-0" />

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                  <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pl-0 sm:pl-0">
                    <Transition.Child
                      as={Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="-translate-x-full"
                      enterTo="-translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="-translate-x-0"
                      leaveTo="-translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                        <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                          <div className="p-6">
                            <div className="flex items-start justify-between">
                                <button
                                  type="button"
                                  className="relative rounded-md bg-white focus:ring-2 focus:ring-indigo-500"
                                  style={{color: "#00E52E"}}
                                  onClick={() => setShowMenu(false)}
                                >
                                  <span className="absolute -inset-2.5" />
                                  <span className="sr-only">Close panel</span>
                                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>
                          </div>
                          <ul role="list" className="flex-1 divide-y divide-gray-200 overflow-y-auto">
                            {baasAllowed && (
                              <li>
                                <div className="group relative flex items-center px-5 py-6">
                                  <a onClick={()=>getUrl('home')} className="-m-1 block flex-1 p-1">
                                    <div className="absolute inset-0 group-hover:bg-gray-50" aria-hidden="true" />
                                    <div className="relative flex min-w-0 flex-1 items-center">
                                      <span className="relative inline-block flex-shrink-0">
                                        <img className="h-6 w-6" src={require("../../assets/imgs/m-dashboard.svg").default} alt="" />
                                      </span>
                                      <div className="ml-4 truncate">
                                        <p className="truncate text-lg font-medium font-bold text-gray-900">Dashboard</p>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </li>
                            )}

                            {rampsAllowed && (
                              <li>
                                <div className="group relative flex items-center px-5 py-6">
                                  <a onClick={() => getUrl('ramps')} className="-m-1 block flex-1 p-1">
                                    <div className="absolute inset-0 group-hover:bg-gray-50" aria-hidden="true" />
                                    <div className="relative flex min-w-0 flex-1 items-center">
                                      <span className="relative inline-block flex-shrink-0">
                                        <img className="h-6 w-6" src={require("../../assets/imgs/m-dashboard.svg").default} alt="" />
                                      </span>
                                      <div className="ml-4 truncate">
                                        <p className="truncate text-lg font-medium font-bold text-gray-900">Ramps / Remessa</p>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </li>
                            )}



                              


                              


                              <li>
                                <div className="group relative flex items-center px-5 py-6">
                                  <a onClick={()=>getUrl('signOut')} className="-m-1 block flex-1 p-1">
                                    <div className="absolute inset-0 group-hover:bg-gray-50" aria-hidden="true" />
                                    <div className="relative flex min-w-0 flex-1 items-center">
                                      <span className="relative inline-block flex-shrink-0">
                                        <img className="h-6 w-6" src={require("../../assets/imgs/ico-logout.svg").default} alt="" />
                                      </span>
                                      <div className="ml-4 truncate">
                                        <p className="truncate text-lg font-medium font-bold text-gray-900">Sair</p>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </li>
                          </ul>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </div>
      </span>
    </section>
  );
}

export default SideMenu;